// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zX_4I","badges":"styles_badges__1839w"};